import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { Col, Row } from '@op/opds.opux';

interface Props {
  profileText: string;
  timePeriodText: string;
  activityText: string;
}

const ProfileColumns = (props: Props): ReactElement => {
  const { profileText, timePeriodText, activityText } = props;
  const locale = (document.documentElement.lang || 'fi').slice(0, 2);
  const columnSize = locale === 'en' ? 3 : 2;

  return (
    <Row className="investoracademy-vertical-flex-align investoracademy-profile-row">
      <Col
        xs={12}
        md={4}
        className="investoracademy-profile-column investoracademy-profile-left"
      >
        <h4 className="investoracademy-profile-title">
          <Message id="course5.investorColumn.title" />
        </h4>
        <p className="investoracademy-profile-text">
          <Message id={profileText} />
        </p>
      </Col>
      <Col
        xs={12}
        md={columnSize}
        className="investoracademy-profile-column investoracademy-profile-center"
      >
        <h4 className="investoracademy-profile-title">
          <Message id="course5.investmentTime.title" />
        </h4>
        <p className="investoracademy-profile-text">
          <Message id={timePeriodText} />
        </p>
      </Col>
      <Col
        xs={12}
        md={4}
        className="investoracademy-profile-column investoracademy-profile-right"
      >
        <h4 className="investoracademy-profile-title">
          <Message id="course5.activityLevel.title" />
        </h4>
        <p className="investoracademy-profile-text">
          <Message id={activityText} />
        </p>
      </Col>
    </Row>
  );
};

export default ProfileColumns;
